import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'carm-public-menu-html-fr',
  templateUrl: './public-menu-html-fr.component.html',
  styleUrls: ['./public-menu-html-fr.component.scss'],
})
export class PublicMenuHtmlFrComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
